import { BrandForm } from "Components/BrandProfile/BrandForm";

export const AddEditBrand = () => {
  return <BrandForm />;
};
